// extracted by mini-css-extract-plugin
export default {"offersContent":"styles_offersContent__-jWSN","loader":"styles_loader__1Ey+y","offersPageWrapper":"styles_offersPageWrapper__L73fb"};